import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { EmailResolutionResponseItem } from '../../features/email-response/models/email-response.model';

export interface EmailResolutionResponsesClient {
  getEmailResolutionResponses(): Observable<EmailResolutionResponseItem[]>;
}

export const EMAIL_RESOLUTION_RESPONSES_CLIENT =
  new InjectionToken<EmailResolutionResponsesClient>('EMAIL_RESOLUTION_RESPONSES_CLIENT');
